import React, { FC, memo } from 'react';
import { LogsSearch } from '../logs.types';
import { convertDateToNeedFormat, sameLocalDay } from '../../../utils/convertDateHandlers';
import cls from './LogsFilters.module.scss';
import { MdOutlineClose } from 'react-icons/md';
import { useAppDispatch } from '../../../hooks/defaultHooks';
import { clearLogsFieldSearch } from '../../../store/slices/logsFilterSlice';

type LogsFiltersProps = {
  filters: LogsSearch & {
    objectEmail: string;
  };
};

const LogsFilters: FC<LogsFiltersProps> = memo((props) => {
  const { filters } = props;
  const dispatch = useAppDispatch();
  // the bounds are UTC instants of local midnights: compare the local days, not the UTC dates
  const checkDateEqual = (start: string, end: string) => {
    if (start !== '' && end !== '') {
      return sameLocalDay(start, end);
    }
    return;
  };
  const deleteFilterField = (field: keyof LogsSearch) => {
    if (field === 'startDateTime') {
      dispatch(clearLogsFieldSearch({ key: 'startDateTime' }));
      dispatch(clearLogsFieldSearch({ key: 'endDateTime' }));
    } else if (field === 'ip') {
      dispatch(clearLogsFieldSearch({ key: field }));
    } else if (field === 'objectId') {
      dispatch(clearLogsFieldSearch({ key: field }));
    }
  };
  return (
    <div className={cls.LogsFilters}>
      {checkDateEqual(filters.startDateTime, filters.endDateTime) && filters.startDateTime && (
        <div className={cls.Item}>
          <span>
            Date: {convertDateToNeedFormat({ date: filters.startDateTime, format: 'date' })}
          </span>
          <button
            className={cls.DeleteBtn}
            onClick={() => deleteFilterField('startDateTime')}
            type="button"
          >
            <MdOutlineClose />
          </button>
        </div>
      )}
      {!checkDateEqual(filters.startDateTime, filters.endDateTime) && filters.startDateTime && (
        <div className={cls.Item}>
          <span>
            Time period: {convertDateToNeedFormat({ date: filters.startDateTime, format: 'date' })}{' '}
            - {convertDateToNeedFormat({ date: filters.endDateTime, format: 'date' })}
          </span>
          <button
            className={cls.DeleteBtn}
            onClick={() => deleteFilterField('startDateTime')}
            type="button"
          >
            <MdOutlineClose />
          </button>
        </div>
      )}
      {filters.ip && (
        <div className={cls.Item}>
          <span>IP address: {filters.ip}</span>
          <button className={cls.DeleteBtn} onClick={() => deleteFilterField('ip')} type="button">
            <MdOutlineClose />
          </button>
        </div>
      )}
      {filters.objectId && (
        <div className={cls.Item}>
          <span>Account: {filters.objectEmail}</span>
          <button
            className={cls.DeleteBtn}
            onClick={() => deleteFilterField('objectId')}
            type="button"
          >
            <MdOutlineClose />
          </button>
        </div>
      )}
    </div>
  );
});

export default LogsFilters;
